import { ChangeDetectionStrategy, Component } from '@angular/core';
import { KazaplanFullscreenService } from '../kazaplan-fullscreen.service';
import { PlanMediaType } from '../../../../shared/models/kaza/plan';
import { OnDestroyComponent } from '../../../../shared/components/on-destroy/on-destroy.component';
import { fadeInAnimation } from '../../../../shared/animations/fade-in.animation';
import { MediaQueriesService } from '../../../../shared/services/utilities/media-queries.service';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';
import { ObservableProperty } from '../../../../utils/decorators/observable-property.decorator';
import { BehaviorSubject } from 'rxjs';
import { UserStoreService } from '../../../../shared/services/state-management/user-store.service';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsPen } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-pen.icon';
import { kzIconsDiscover } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-discover.icon';
import { kzIconsDice } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-dice.icon';
import { Media } from '@adeo/ngx-kozikaza-api/kazaplan';

@Component({
  selector: 'app-kazaplan-fullscreen-sidebar-medias',
  animations: [fadeInAnimation],
  templateUrl: './kazaplan-fullscreen-sidebar-medias.component.html',
  styleUrls: ['./kazaplan-fullscreen-sidebar-medias.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@AutoUnsubscribe()
export class KazaplanFullscreenSidebarMediasComponent extends OnDestroyComponent {

  public kazaplanMediasTypes = PlanMediaType;

  @ObservableProperty(false)
  browserIsValid: boolean;
  public browserIsValid$: BehaviorSubject<boolean>;

  constructor(
    public kps: KazaplanFullscreenService,
    public mediaQueriesService: MediaQueriesService,
    public readonly userStoreService: UserStoreService,
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    super();
    this.kzIconsRegistryService.registerIcons([kzIconsPen, kzIconsDiscover, kzIconsDice]);
    this.browserIsValid = !this.mediaQueriesService.detectIE();
  }

  filterMedias(mediaFilter?: string): void {
    this.kps.setPlanMediasFilter({page: 1, mediaFilter: (mediaFilter) ? mediaFilter as PlanMediaType : null});
  }

  trackMedia(index: number, item: Media): string {
    return (!item) ? null : item.id;
  }

  onScroll() {
    this.kps.nextPlanMediaFilter();
  }
}
